// extracted by mini-css-extract-plugin
export default {"section":"OrderHistory_section__moRwI","list":"OrderHistory_list__EdYHP"};